import { mainFetchUrl } from "../constants/urls";
import { createSearchParams, FetchFunction } from "./util";

export const fetchFavoriteMovies = (
  fetchFunction: FetchFunction,
  accountId: string,
  sessionId: string,
  page: number = 1,
  sortBy: string = "desc"
) => {
  const searchParams = createSearchParams();
  searchParams.append("session_id", sessionId);
  searchParams.append("page", `${page}`);
  searchParams.append("sort_by", `created_at.${sortBy}`);

  return fetchFunction(`${mainFetchUrl}/account/${accountId}/favorite/movies?${searchParams.toString()}`);
};

export const updateFavoriteStatus = (
  fetchFunction: FetchFunction,
  sessionId: string,
  accountId: string,
  movieId: number,
  favoriteStatus: boolean
) => {
  const requestHeader: HeadersInit = { "Content-Type": "application/json" };
  const requestBody = { media_type: "movie", media_id: movieId, favorite: favoriteStatus };

  const searchParams = createSearchParams();
  searchParams.append("session_id", sessionId);

  return fetchFunction(
    `${mainFetchUrl}/account/${accountId}/favorite?${searchParams.toString()}`,
    "post",
    JSON.stringify(requestBody),
    requestHeader
  );
};
